import { createRoute, Navigate, Outlet } from "@tanstack/react-router";
import { Route as dashboardLayout } from "./_layout";

export const Route = createRoute({
  getParentRoute: () => dashboardLayout,
  path: "/dashboard/patients/$patientId",
  component: PatientWorkspace,
});

/** Bare `/dashboard/patients/$patientId` lands on Summary. */
export const IndexRoute = createRoute({
  getParentRoute: () => Route,
  path: "/",
  component: PatientWorkspaceIndex,
});

function PatientWorkspaceIndex() {
  const { patientId } = Route.useParams();
  return (
    <Navigate to="/dashboard/patients/$patientId/summary" params={{ patientId }} replace />
  );
}

/**
 * Layout for one patient's workspace. It holds no chrome of its own, since each
 * section renders its own header so Records can drop the stat strip and use the
 * full height for its tabs. The `min-w` floor makes narrow viewports scroll
 * sideways rather than collapse the dense record layouts.
 */
function PatientWorkspace() {
  return (
    <div className="flex min-h-svh min-w-[64rem] flex-col">
      <Outlet />
    </div>
  );
}
